import {Injectable, inject} from '@angular/core'
import {Permision as UserPermission} from '@models/user-permissions'
import {UVEuser} from '@models/uve-user'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {PermissionsService} from './permissions.service'

/**
 * Variante embebida de `PermissionsService`.
 *
 * @description
 * En modo embebido los permisos vienen en el payload (`EmbeddedStoreService.userPermissions`)
 * y no hay un `InfoUsers` en PouchDB que consultar. Se desactiva el dispatch al store
 * porque la app anfitriona ya gestiona su propio estado global.
 */
@Injectable({
  providedIn: 'root',
})
export class PermissionsEmbeddedService extends PermissionsService {
  private readonly orderEmbbdedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)

  protected override dispatchPrermissions = (user: UVEuser): void => {}

  override getLocalPermissions = (): Array<UserPermission> => this.orderEmbbdedStoreService.userPermissions()

  override getPermissionsFromApi = async (username: string): Promise<UserPermission[]> =>
    this.orderEmbbdedStoreService.userPermissions()
}
